import React, { useState } from "react";
import T from "prop-types";
import styled from "styled-components/macro";
import Typography from "commons/components/Typography";
import Flexbox from "commons/components/Flexbox";
import NumberStepper from "commons/components/NumberStepper";
import Ingredient from "./Ingredient";
import { BREAKPOINTS } from "commons/util/breakpoints";
import { IngredientsBox } from "App/Recipes/components/Recipes.styles";
import Tooltip from "commons/components/Tooltip";
import { useTranslation } from "react-i18next";

const IngredientsBoxStyled = styled(IngredientsBox)`
  width: 350px;
  max-width: 100%;

  @media (max-width: ${BREAKPOINTS.medium}) {
    width: 100%;
  }
`;

const Category = styled(Typography)`
  padding: 12px 8px 0;
`;

function Ingredients({ className, ingredients, activeStep, servings: defaultServings = 1 }) {
  const { t } = useTranslation();
  const [servings, setServings] = useState(defaultServings);

  return (
    <IngredientsBoxStyled className={className}>
      <Flexbox justifyContent="space-between" alignItems="center" marginX={8} marginBottom={16}>
        <Typography variant="h3">{t("Recipes.Ingredients")}</Typography>
        <Tooltip label={t("Recipes.Servings")}>
          <NumberStepper value={servings} onChange={setServings} />
        </Tooltip>
      </Flexbox>
      <Flexbox flexDirection="column" alignItems="flex-start" gap={8}>
        {ingredients.map((ingredient, i) => {
          const isHighlighted = activeStep && activeStep.text.includes(`data-ingredient-id=${ingredient.id}>`);

          if (ingredient.isCategory) {
            return (
              <Category key={i} variant="h4">
                {ingredient.label}
              </Category>
            );
          } else {
            const displayedAmount = +(ingredient.amount * (servings / defaultServings)).toFixed(2);
            return (
              <Ingredient
                key={i}
                amount={displayedAmount}
                unit={ingredient.unit}
                label={ingredient.label}
                note={ingredient.note}
                isHighlighted={isHighlighted}
              />
            );
          }
        })}
      </Flexbox>
    </IngredientsBoxStyled>
  );
}

Ingredients.propTypes = {
  className: T.string,
  ingredients: T.array.isRequired,
  activeStep: T.object,
  servings: T.number,
};

export default Ingredients;
